module.exports = function(TomSelect) {
	const newNumberRadio = document.getElementById("new-number");
	const numberSelectSpinner = document.getElementById("load-numbers-spinner");

	const numberType = new TomSelect("#number-type", {
		// allowEmptyOption: true
		render: {
			no_results: function(data, escape) {
				return "<div class='no-results'>" + escape(this.input.dataset.noRecords) + "</div>";
			}
		}
	});
		
	const newNumberSelection = new TomSelect("#number-select", {
		allowEmptyOption: true,
		valueField: "number",
		labelField: "number",
		searchField: "number",
		create: false,
		render: {
			option: function(data) {

				// console.log(data);
				return `<div data-value="${data.number}" data-record-signature="${data.recordSignature}" class='item'>${data.number}</div>`;
			},
			no_results: function(data, escape) {
				return "<div class='no-results'>" + escape(this.input.dataset.noRecords) + "</div>";
			}
		},

		onChange: function(value) {

			document.getElementById("record-signature-input")
				.value = this.options[value]?.recordSignature ?? "";
		}
	});

	const subscriptionType = document.getElementById("number-type");
	subscriptionType.addEventListener("change", function() {
	
		if ( this.value.trim().length == "" ) return false;

		numberType.disable();
		numberSelectSpinner.classList.remove("hidden");
		numberSelectSpinner.classList.add("inline-block");

		newNumberSelection.clear();
		newNumberSelection.clearOptions();
		newNumberSelection.disable();

		axios.post("/get-new-numbers", {
			subscriptionType: this.value
		})
		.then( res => {

			// console.log(res.data);

			for (let i = 0; i < res.data.length; i++) {

				// console.log(res.data[i].RecordSignature);

				newNumberSelection.addOption({
					number: res.data[i].Number,
					recordSignature: res.data[i].RecordSignature
				});
			}

			newNumberSelection.enable();
		})
		.catch( err => {
			console.log(err);
		})
		.then( () => {
			numberSelectSpinner.classList.add("hidden");
			numberSelectSpinner.classList.remove("inline-block");
			numberType.enable();
		})
	});

	newNumberRadio.addEventListener("change", function() {

		newNumberSelection.clear();
		newNumberSelection.clearOptions();
		newNumberSelection.disable();

		numberType.clear();
	});
};